import { Box, Button, Container, Grid, Slider, Typography } from '@mui/material'
import { lighten, useTheme } from '@mui/material/styles'
import axios from 'axios'
import * as _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-final-form'
import { BallTriangle } from 'react-loader-spinner'

import { FormSectionProps } from '../../interfaces/form'
import FormWizard from '../wizard'

import Carousel from 'react-multi-carousel'

import 'react-multi-carousel/lib/styles.css'
import './quoteList.css'

import CallIcon from '../../assets/call_icon.png'
import { trackGAEvent } from '../../util'
import Person1 from '../assets/person1'
import Person10 from '../assets/person10'
import Person2 from '../assets/person2'
import Person3 from '../assets/person3'
import Person4 from '../assets/person4'
import Person5 from '../assets/person5'
import Person6 from '../assets/person6'
import Person7 from '../assets/person7'
import Person8 from '../assets/person8'
import Person9 from '../assets/person9'

const { REACT_APP_COMMS_URL, REACT_APP_TOKEN_PASSCODE } = process.env

type IpipelineResult = {
  livesAssured?: string
  premiumType?: string
  term?: number
  lifeCoverAmount?: number
  criticalIllnessCoverAmount?: number
  waiverOfPremium?: string
  policyInterestRate?: number
  totalPermanentDisability?: boolean
  toAge?: number
  benefitAmount?: number
  life?: number
  criticalIllness?: number
  incomeProtection?: number
  lifeAndCriticalIllness?: number
  any?: number
  premium?: number
  error?: string
}

type Response = {
  getFamilyIncomeBenefit?: IpipelineResult
  getDecreasingTerm?: IpipelineResult
  getDecreasingTermCritical?: IpipelineResult
  getWholeOfLife?: IpipelineResult
  getWholeOfLifeOverFifty?: IpipelineResult
  getLevelTerm?: IpipelineResult
  getLevelTermCritical?: IpipelineResult
  getIncomeProtection?: IpipelineResult
  getRiskRealties?: IpipelineResult
  getBusinessProtectionDecreasingData?: IpipelineResult
  getBusinessProtectionLevelData?: IpipelineResult
}

type QuoteItemProps = {
  quoteTitle?: string
  lifeInsuranceCover?: number
  criticalIllnessCover?: number
  quoteDescription?: string
  benefitAmount?: number
  toAge?: number
  viewLink?: string
  error?: string
  premium?: number
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
}

const overrideSliderStyle = {
  '& .MuiSlider-thumb': {
    width: 30,
    height: 30,
    '&:hover': {
      boxShadow: 'none',
    },
    '&.Mui-active': {
      boxShadow: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    background: 'none',
    color: 'primary.main',
    fontSize: 24,
    marginBottom: 16,
  },
}

const QuoteItem = ({
  quoteTitle,
  quoteDescription,
  premium,
  viewLink,
}: QuoteItemProps) => {
  const theme = useTheme()

  if (!premium || premium === -1) return null

  return (
    <Box sx={{ height: '100%' }}>
      <Box
        sx={{
          minHeight: '287px',
          height: '100%',
          width: '90%',
          margin: 'auto',
          borderRadius: '30px',
          background: '#FFF',
          padding: '20px 15px',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          boxShadow: '0px 0px 5px 1px rgba(0, 0, 0, 0.3)',
          '@media screen and (max-width: 767px)': {
            width: '90%',
            margin: 'auto',
          },
        }}
      >
        <Box
          sx={{
            minWidth: '170px',
            minHeight: '75px',
            background: theme.palette.primary.main,
            position: 'absolute',
            top: -20,
            right: -10,
            padding: '15px 20px',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // '@media screen and (max-width: 767px)': {
            //   top: 0,
            //   right: 0,
            //   borderTopRightRadius: '30px',
            // },
          }}
        >
          <Typography fontSize={24} color="#FFF">
            <strong>£ {premium}</strong>/month
          </Typography>
        </Box>
        <Typography
          color="primary"
          fontSize={20}
          fontWeight={700}
          sx={{
            width: 'calc(100% - 200px)',
          }}
        >
          {quoteTitle}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            flex: 1,
          }}
        >
          {quoteDescription}
        </Typography>
        {/* {viewLink ? (
          <Button
            color="primary"
            variant="contained"
            href={viewLink}
            target="_blank"
            disableElevation
            sx={{
              borderRadius: '10px',
              width: '186px',
              margin: 'auto',
            }}
            disableRipple
          >
            View More Details
          </Button>
        ) : null} */}
      </Box>
    </Box>
  )
}

const QuoteList = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const theme = useTheme()
  //@ts-ignore
  const custom = theme?.custom
  const values = form.getState().values
  const [isLoading, setIsLoading] = useState(true)
  const [input, setInput] = useState({
    lifeCoverAmount: 250000,
    insuranceTerm: 20,
  })

  const [hideAppointmentButton, setHideAppointmentButton] = useState(false)

  const [ipipelineResult, setIpipelineResult] = useState<Response>({})

  const calculateDOB = (age: number) => {
    const year = new Date().getFullYear()
    const diff = year - age
    return `${diff}-${(`0` + (new Date().getMonth() + 1)).slice(-2)}-${(
      `0` + new Date().getDate()
    ).slice(-2)}`
  }

  const getBodyParams = (coverAmount: number, term: number) => {
    const { age, isSmoker, postcode } = values

    return {
      clientDetails: {
        firstLife: {
          dateOfBirth: calculateDOB(age),
          isSmoker: isSmoker === 'true' ? true : false,
          // gender,
          employmentDetails: {
            ...((values?.employment === 'Employed' ||
              values?.employment === 'SelfEmployed' ||
              values?.employment === 'Contractor') && {
              income: values?.income,
              origoOccupationCode: values?.occupation?.code,
            }),
            employment:
              values?.employment === 'Contractor'
                ? 'SelfEmployed'
                : values?.employment,
          },
          postcode,
        },
        ...(values?.isPartnerCovered === 'true' && {
          secondLife: {
            dateOfBirth: calculateDOB(values?.partnerAge),
            isSmoker: values?.isPartnerSmoker === 'true' ? true : false,
            employmentDetails: {
              ...((values?.partnerEmployment === 'Employed' ||
                values?.partnerEmployment === 'SelfEmployed' ||
                values?.partnerEmployment === 'Contractor') && {
                income: values?.partnerIncome,
                origoOccupationCode: values?.partnerOccupation?.code,
              }),
              employment:
                values?.partnerEmployment === 'Contractor'
                  ? 'SelfEmployed'
                  : values?.partnerEmployment,
            },
            postcode,
          },
        }),
      },
      benefitDetails: {
        livesAssured: 'First',
        term,
        premiumType: 'Guaranteed',
        lifeCoverAmount: coverAmount,
      },
    }
  }

  const getInsurances = async (coverAmount: number, term: number) => {
    setIsLoading(true)

    const blockItems = [
      'getFamilyIncomeBenefit',
      'getDecreasingTerm',
      'getDecreasingTermCritical',
      'getWholeOfLife',
      'getWholeOfLifeOverFifty',
      'getLevelTerm',
      'getLevelTermCritical',
      'getIncomeProtection',
      'getRiskRealties',
      // 'getBusinessProtectionDecreasingData',
      // 'getBusinessProtectionLevelData',
    ]

    const {
      data: { result },
    } = await axios.post(
      `${REACT_APP_COMMS_URL}/comms/api/ipipeline?block=${blockItems.join(
        ','
      )}`,
      getBodyParams(coverAmount, term)
    )

    setIpipelineResult(result)

    setIsLoading(false)
  }

  /*eslint-disable  react-hooks/exhaustive-deps */
  const topLevelDebounce = useCallback(_.debounce(getInsurances, 1000), [])

  const renderCarousel = () => {
    const carouselItems = [
      {
        title: 'Decreasing Term Life Insurance',
        description: `Pays out a lump sum on death; however the sum assured (death benefit) reduces over time. This type of policy is normally used to protect a repayment mortgage.`,
        premium: ipipelineResult?.getDecreasingTerm?.premium,
        // viewLink: 'http://info.spf.co.uk/life-cover-campaign',
      },
      {
        title: 'Decreasing Term Critical Cover',
        description: `Pays out a lump sum on death; however the sum assured (death benefit) reduces over time. This type of policy is normally used to protect a repayment mortgage.`,
        premium: ipipelineResult?.getDecreasingTermCritical?.premium,
        // viewLink: 'http://info.spf.co.uk/life-cover-campaign',
      },
      {
        title: 'Level Term Life Insurance',
        description: `Pays out a lump sum on death, the sum assured (death benefit) remains the same for the term.    At the end of the term, if a claim has not been made, the policy ceases.  You can choose increasing level of cover which will mean the premium also increases.  This type of policy does not build up a cash value over the term.`,
        premium: ipipelineResult?.getLevelTerm?.premium,
        // viewLink: 'http://info.spf.co.uk/life-cover-campaign',
      },
      {
        title: 'Level Term Critical Cover',
        description: `Pays out a lump sum on death, the sum assured (death benefit) remains the same for the term.    At the end of the term, if a claim has not been made, the policy ceases.  You can choose increasing level of cover which will mean the premium also increases.  This type of policy does not build up a cash value over the term.`,
        premium: ipipelineResult?.getLevelTermCritical?.premium,
        // viewLink: 'http://info.spf.co.uk/life-cover-campaign',
      },
      {
        title: 'Family Income Benefit',
        description: `A life assurance policy which will provide an annual lump sum payment upon death of the life assured for the remaining term of the policy, primarily used to provide Family Protection.`,
        premium: ipipelineResult?.getFamilyIncomeBenefit?.premium,
      },
      {
        title: 'Income Protection',
        description: `Covers a proportion of your income if you are unable to work due to illness or disability`,
        premium: ipipelineResult?.getIncomeProtection?.premium,
        // viewLink: 'http://info.spf.co.uk/income-protection-campaign',
      },
      {
        title: 'Whole Of Life',
        description:
          'Guaranteed payment of the sum assured (death benefit) upon death.',
        premium: ipipelineResult?.getWholeOfLife?.premium,
      },
      {
        title: 'Whole Of Life Over 50',
        description:
          'Guaranteed payment of the sum assured (death benefit) upon death.',
        premium: ipipelineResult?.getWholeOfLifeOverFifty?.premium,
      },
      // {
      //   title: 'Business Protection Decreasing Insurance',
      //   description: '',
      //   premium: ipipelineResult?.getBusinessProtectionDecreasingData?.premium,
      // },
      // {
      //   title: 'Business Protection Insurance',
      //   description:
      //     "Helps to protect your client's business should a director, partner, member or key employee suffer a critical illness or die. Having this financial protection in place is vital in allowing businesses to recover quickly and minimise the impact should the worst happen.",
      //   premium: ipipelineResult?.getBusinessProtectionLevelData?.premium,
      // },
    ]

    return (
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={false}
        responsive={responsive}
        autoPlay={true}
        autoPlaySpeed={10000}
        infinite={false}
        containerClass="carousel-container"
        itemClass="carousel-item-margin-30"
        // removeArrowOnDeviceType={['tablet', 'mobile']}
      >
        {carouselItems
          .map((item) => {
            if (!item.premium || item.premium === -1) return null

            return (
              <QuoteItem
                key={item.title}
                quoteTitle={item.title}
                quoteDescription={item.description}
                premium={item.premium}
                // viewLink={item.viewLink}
              />
            )
          })
          .filter(Boolean)}
      </Carousel>
    )
  }

  const renderPersonPercentage = (percentage: number) => (
    <Box marginBottom="15px">
      <Person1
        fillColor={percentage > 0 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person2
        fillColor={percentage >= 20 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person3
        fillColor={percentage >= 30 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person4
        fillColor={percentage >= 40 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person5
        fillColor={percentage >= 50 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person6
        fillColor={percentage >= 60 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person7
        fillColor={percentage >= 70 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person8
        fillColor={percentage >= 80 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person9
        fillColor={percentage >= 90 ? theme.palette.primary.main : '#8c95a4'}
      />
      <Person10
        fillColor={percentage >= 100 ? theme.palette.primary.main : '#8c95a4'}
      />
    </Box>
  )

  const renderRiskRealtiesDescription = (
    percentage: number,
    coverageText: string
  ) => {
    if (percentage === 0) {
      return (
        <Typography variant="body1">
          One of our advisers will be able to help you here.
        </Typography>
      )
    }

    return (
      <Typography variant="body1">
        You have {percentage}% probability of needing to claim the{' '}
        <span style={{ color: theme.palette.primary.main }}>
          {coverageText}
        </span>{' '}
        in the duration of the specified term.
      </Typography>
    )
  }

  const renderRiskRealtyItem = (percentage: number, coverText: string) => {
    const borderStyle = {
      borderLeft: '1px solid #8c95a4',
      padding: '0px 10px',
      height: '100%',
      '@media screen and (max-width: 991px)': {
        borderLeft: 'none',
      },
    }

    return (
      <Box sx={borderStyle}>
        {renderPersonPercentage(percentage)}
        {renderRiskRealtiesDescription(percentage, coverText)}
      </Box>
    )
  }

  const renderRiskRealties = () => {
    return (
      <Box minHeight="275px" sx={{ background: '#F4F4F4', padding: '50px' }}>
        <Grid container spacing={2} marginBottom="55px">
          <Grid item xs={12} sm={6} lg={3}>
            {renderRiskRealtyItem(
              Math.round(ipipelineResult?.getRiskRealties?.life! * 100),
              'life cover'
            )}
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            {renderRiskRealtyItem(
              Math.round(
                ipipelineResult?.getRiskRealties?.criticalIllness! * 100
              ),
              'critical illness cover'
            )}
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            {renderRiskRealtyItem(
              Math.round(
                ipipelineResult?.getRiskRealties?.incomeProtection! * 100
              ),
              'income protection'
            )}
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            {renderRiskRealtyItem(
              Math.round(ipipelineResult?.getRiskRealties?.any! * 100),
              'life cover, critical illness, or income protection'
            )}
          </Grid>
        </Grid>
        <Typography color="primary" variant="body1">
          * Please note that these are indicative indications of premiums based
          on market average policies and premiums. This does not constitute a
          quotation, your Adviser will provide you with a quotation
        </Typography>
      </Box>
    )
  }

  useEffect(() => {
    topLevelDebounce(input.lifeCoverAmount, input.insuranceTerm)
  }, [input, topLevelDebounce])

  useEffect(() => {
    setHideAppointmentButton(custom?.appConfig?.hideAppointmentButton === 'yes')
  }, [])

  useEffect(() => {
    trackGAEvent(custom?.googleAnalyticsTrackingId, {
      category: 'MeetParkerChat',
      action: 'Insurance Quote Loaded',
    })
  }, [])

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Container maxWidth="md">
            <Grid container spacing={8} sx={{ mb: '35px' }}>
              <Grid item xs={12}>
                <Typography
                  fontWeight={700}
                  fontSize={24}
                  lineHeight="29px"
                  // marginBottom="20px"
                >
                  Please amend the total cover amount and term slider to update
                  your quote
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: 'primary.main',
                    minHeight: '300px',
                    minWidth: '100%',
                    padding: '18px',
                    display: 'flex',
                    height: '100%',
                    flexDirection: 'column',
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    lineHeight="29px"
                    textTransform="uppercase"
                    textAlign="center"
                    color="#FFF"
                    marginBottom="8px"
                  >
                    Amount
                  </Typography>
                  <Typography
                    variant="body1"
                    color="#FFF"
                    textAlign="center"
                    sx={{ flex: 1 }}
                  >
                    This is how much cover you're taking out and how much your
                    policy would pay out (depending on the type) if you need to
                    claim
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      height: '140px',
                      padding: '10px 30px',
                    }}
                  >
                    <Slider
                      defaultValue={250000}
                      step={1000}
                      min={1000}
                      max={1000000}
                      marks={[
                        {
                          value: 1000,
                          label: <strong>£ 1000</strong>,
                        },
                        {
                          value: 1000000,
                          label: <strong>£ 100000</strong>,
                        },
                      ]}
                      valueLabelDisplay="on"
                      sx={{ ...overrideSliderStyle, mt: 8 }}
                      onChange={(e: Event, value: number | number[]) => {
                        setInput({
                          ...input,
                          lifeCoverAmount: value as number,
                        })
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: 'primary.main',
                    minHeight: '300px',
                    minWidth: '100%',
                    padding: '18px',
                    display: 'flex',
                    height: '100%',
                    flexDirection: 'column',
                  }}
                >
                  <Typography
                    fontWeight={700}
                    fontSize={24}
                    lineHeight="29px"
                    textTransform="uppercase"
                    textAlign="center"
                    color="#FFF"
                    marginBottom="8px"
                  >
                    Term
                  </Typography>
                  <Typography
                    variant="body1"
                    color="#FFF"
                    textAlign="center"
                    marginBottom="8px"
                    sx={{ flex: 1 }}
                  >
                    This is how long the length of your cover policy will be
                  </Typography>
                  <Box
                    sx={{
                      backgroundColor: 'white',
                      minHeight: '140px',
                      padding: '10px 30px',
                    }}
                  >
                    <Slider
                      defaultValue={20}
                      step={1}
                      min={1}
                      max={99}
                      marks={[
                        {
                          value: 1,
                          label: <strong>1</strong>,
                        },
                        {
                          value: 99,
                          label: <strong>99</strong>,
                        },
                      ]}
                      valueLabelDisplay="on"
                      sx={{ ...overrideSliderStyle, mt: 8 }}
                      onChange={(e: Event, value: number | number[]) => {
                        setInput({
                          ...input,
                          insuranceTerm: value as number,
                        })
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
          <Box minHeight="300px" marginBottom="40px">
            {isLoading ? (
              <Box
                height="100%"
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ flexDirection: 'column' }}
              >
                <BallTriangle
                  height="100"
                  width="100"
                  color={theme.palette.primary.main}
                  ariaLabel="loading"
                />
                <Typography variant="h6" color="primary" marginTop="20px">
                  Let me just scan the market
                </Typography>
              </Box>
            ) : (
              renderCarousel()
            )}
          </Box>
          {!isLoading && renderRiskRealties()}
          {!isLoading && !hideAppointmentButton && (
            <div style={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                disableRipple
                type="submit"
                sx={{
                  color: '#FFF',
                  borderWidth: 2,
                  padding: '16px 40px',
                  outline: 'none',
                  borderStyle: 'solid',
                  borderColor: theme.palette.primary.main,
                  borderRadius: 30,
                  fontSize: 14,
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  marginTop: 4,
                  backgroundColor: theme.palette.primary.main,
                  boxShadow: `0px 12px 18px -6px ${lighten(
                    theme.palette.primary.main,
                    0.73
                  )}`,
                  '&:hover': {
                    transform: 'scale(1.1)',
                    background: '#FFF',
                    border: `2px solid ${theme.palette.primary.main}`,
                    color: theme.palette.primary.main,
                  },
                }}
              >
                <img
                  src={CallIcon}
                  alt="Speak with an advisor"
                  width="30"
                  height="30"
                  style={{
                    marginRight: '10px',
                  }}
                />{' '}
                Speak with an advisor
              </Button>
            </div>
          )}
          {/* {!isLoading && (
            <Grid container spacing={2} marginTop="55px">
              <Grid item xs={12} md={6}>
                <Box
                  height="515px"
                  display="flex"
                  flexDirection="column"
                  sx={{
                    background: '#F4F4F4',
                    border: '1px solid #DADADA',
                    borderRadius: 10,
                    boxSizing: 'border-box',
                  }}
                >
                  <Box
                    flex="1"
                    padding="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <iframe
                      width="100%"
                      height="400"
                      src="https://www.youtube.com/embed/3-5I400TKS8"
                      title="SPF Private Clients"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </Box>
                  <Box
                    height="60px"
                    sx={{
                      background: '#D4D4D4',
                      borderBottomLeftRadius: 20,
                      borderBottomRightRadius: 20,
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box padding="40px">
                  <Typography
                    fontSize={32}
                    fontWeight={600}
                    color="#14233C"
                    textTransform="uppercase"
                    marginBottom="20px"
                  >
                    About SPF
                  </Typography>
                  <Typography
                    fontSize={15}
                    fontWeight={400}
                    lineHeight="23.55px"
                    color="#14233C"
                  >
                    SPF is an insurance intermediary and act on behalf of
                    clients and not insurers. We offer a personal recommendation
                    on the basis of a fair and personal analysis of the market.
                    We arrange the policy with the insurer on your behalf. We
                    receive commission from the insurer which is a percentage of
                    the total annual premium you pay.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          )} */}
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default QuoteList
